import { render, staticRenderFns } from "./PlanningIsland.vue?vue&type=template&id=453bc846&"
import script from "./PlanningIsland.vue?vue&type=script&lang=js&"
export * from "./PlanningIsland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports